import React from 'react';
import { Section } from '@fiverr-private/layout_components';
import { getContext } from '@fiverr-private/fiverr_context';
import { CATEGORIES_ID_MAPPER, PJM_BANNER_SUPPORTED_CATEGORY_IDS } from '../../../lib/constants/verticalsData';
import { PjmBanner } from '../PjmBanner/PjmBanner';

interface BannerSectionProps {
    verticalId: number;
    verticalTitle: string;
}

const buildActiveBannerComponent = ({ verticalId, verticalTitle }) => {
    const { experience } = getContext();

    const showProjectPartnerBanner =
        PJM_BANNER_SUPPORTED_CATEGORY_IDS.includes(verticalId) &&
        (experience?.isBusiness || verticalId !== CATEGORIES_ID_MAPPER['writing-translation']);

    if (showProjectPartnerBanner) {
        return <PjmBanner verticalId={verticalId} verticalTitle={verticalTitle} />;
    }
};

export const BannerSection: React.FC<BannerSectionProps> = ({ verticalTitle, verticalId }) => {
    const component = buildActiveBannerComponent({
        verticalId,
        verticalTitle,
    });

    if (!component) {
        return null;
    }

    return (
        <Section paddingBottom="0" paddingTop="14">
            {component}
        </Section>
    );
};
